import { passkeyClient } from "@better-auth/passkey/client"
import { organizationClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

// No baseURL: the auth API is served from the same origin as the app.
export const authClient = createAuthClient({
  plugins: [organizationClient(), passkeyClient()],
})
